import { format as formatCurrency } from 'currency-formatter';
import { map, sum, get, isNil } from 'lodash';

export const arrayToOptions = (data: any) => {
  return map(data, (item: any) => ({
    label: item,
    value: item,
  }));
};

export const convertCentsToDollar = (num: any) => {
  return num / 100;
};

export const dollars = (
  amount: any,
  { precision = 0, showSymbol = true } = {},
) => {
  if (typeof amount !== 'number') {
    return '';
  }
  const formattedDollars =
    amount || precision
      ? formatCurrency(amount / 100, { code: 'USD', precision })
      : '$0';
  return showSymbol ? formattedDollars : formattedDollars.slice(1);
};

export const rateParser = (
  amount: any,
  { precision = 2, showSymbol = true } = {},
) => {
  if (typeof amount !== 'number') {
    return amount;
  }
  const formattedPercentage = amount ? (amount * 100).toFixed(precision) : '0';
  return showSymbol ? `${formattedPercentage}%` : formattedPercentage;
};

export const yesOrNo = (item: any) => {
  return item ? 'Yes' : 'No';
};

export const avgInterestRate = (loans: any) => {
  const activeLoans = loans.filter((item: any) => item.principalBalance !== 0);

  const isMissingDataForAvgInterestRate = !!activeLoans.find(
    (loan: any) => isNil(loan.interestRate) || isNil(loan.principalBalance),
  );
  if (isMissingDataForAvgInterestRate) {
    return '-';
  }

  const weightedBalance = sum(
    activeLoans.map((item: any) => item.principalBalance * item.interestRate),
  );

  const totalBalance = sum(
    activeLoans.map((item: any) => item.principalBalance),
  );

  const weightedAverageInterestRate = weightedBalance / totalBalance;

  return weightedAverageInterestRate;
};

export const isCaresActEligible = (
  federalLoanTypes: any,
  servicerNames: any,
) => {
  if (get(federalLoanTypes, 'isPerkins')) {
    return 'No';
  }
  if (
    get(federalLoanTypes, 'isFfel') &&
    !servicerNames?.some((name: any) => name?.includes('DEPT OF ED'))
  ) {
    return 'No';
  }
  if (!federalLoanTypes || !servicerNames) {
    return 'unknown';
  }

  return 'Yes';
};

export const formatPhone = (phoneNumber: any) =>
  !isNil(phoneNumber)
    ? phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 - $3')
    : '–';

export const getIsSplittable = (string: any) => {
  if (Array.isArray(string)) {
    return string.length > 1;
  }
  if (string?.split(' ')) {
    return string.split(' ').length > 1;
  }
  return false;
};
